import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { TransportOrderIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ShipmentTransportOrderEndpoint } from '../../constants';
import { ShipmentWaybillLoadHistoryData } from './shipment-transport-order-status-history.model';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderStatusHistoryService {
  constructor(private http: WrapperHttpService) {}

  getStatusHistory(transportOrderIdView: TransportOrderIdView): Observable<ShipmentWaybillLoadHistoryData[]> {
    return this.http
      .withLoading()
      .get<ShipmentWaybillLoadHistoryData[]>(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
          ShipmentTransportOrderEndpoint.StatusHistories
        }?${getQueryStringFromObject(transportOrderIdView)}`,
      );
  }
}
